import React from 'react';
import { Box, Typography, Card, CardContent } from '@mui/material';
import './Steps.scss';
import { convertDateFormat, findStatusColor } from '../../../utils/Utils';

const CustomStepper = ({ tasks = [], screen, usertype }) => {
  const isVotingScreen = screen === 'voting';
  return (
    <>
      {isVotingScreen ? (
        <Box
          className="stepper"
          flexDirection={'row'}
          style={{
            display: 'flex',
            whiteSpace: 'nowrap',
            justifyContent: 'center',
            alignItems: 'center'
          }}>
          {tasks?.map((task, index) => (
            <Box
              className="step"
              style={{ width: '300px', alignItems: 'center', justifyContent: 'center' }}
              key={`${index + 1}`}>
              <Box className="step-icon" />
              {/* Connector line, except for the last step */}
              {index !== tasks.length - 1 && <span className="step-connector"></span>}
              <Box className="step-icon-container">
                {/* Step Icon */}
                <Box className="step-icon">
                  {task.status === 'In Progress' && (
                    <Box
                      sx={{
                        width: 16,
                        height: 16,
                        borderRadius: '50%',
                        backgroundColor: 'rgba(0, 92, 188, 1)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}>
                      {/* Inner circle with radius 8 */}
                      <Box
                        sx={{
                          width: 8,
                          height: 8,
                          borderRadius: '50%',
                          backgroundColor: '#FFFFFF'
                        }}
                      />
                    </Box>
                  )}
                  {task.status === 'Completed' ? (
                    <Box
                      sx={{
                        width: 16, // Outer circle size
                        height: 16,
                        borderRadius: '50%',
                        backgroundColor: 'rgba(0, 92, 188, 1)', // Blue outer circle for 'Completed'
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        position: 'relative'
                      }}>
                      {/* White tick for 'Completed' status */}
                      <svg
                        width="10"
                        height="10"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{ position: 'absolute', width: '10px', height: '10px' }}>
                        <path
                          d="M20 6L9 17L4 12"
                          stroke="#FFFFFF"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </Box>
                  ) : (
                    <Box className="step-icon" sx={{ backgroundColor: 'rgba(97, 97, 97, 1)' }} />
                  )}
                </Box>
                {/* Connector line, except for the last step */}
                {index !== tasks.length - 1 && <span className="step-connector"></span>}
              </Box>

              {/* Step Details */}
              <Box className="step-details">
                {/* Step Title */}
                <Typography className="step-title" sx={{ fontSize: '20px' }}>
                  {task.taskName}
                </Typography>
                <Typography
                  component="p"
                  style={{
                    color:
                      task.status === 'Completed'
                        ? 'rgba(58, 58, 58, 1)'
                        : task.status === 'In Progress'
                          ? 'rgba(0, 92, 188, 1)'
                          : 'rgba(58, 58, 58, 1)',
                    fontWeight: task.status === 'In Progress' ? '700' : '400',
                    fontSize: '14px'
                  }}>
                  {task.status}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
      ) : (
        <Card
          className="custom-stepper-card"
          style={{
            overflowX: 'scroll',
            height: '146px',
            padding: '8px',
            borderRadius: '8px',
            background: '#FBFCFE',
            boxShadow: '4px 0px 24px -2px rgba(0, 92, 188, 0.14)'
          }}>
          <CardContent>
            <Box
              className="stepper"
              style={{
                display: 'flex',
                whiteSpace: 'nowrap',
                height: ' 146px'
              }}>
              {tasks.map((task, index) => (
                <Box className="step" key={`${index + 1}`}>
                  {/* Step Title */}
                  <Typography className="step-title" sx={{ fontSize: '12px' }}>
                    {task.taskName.toUpperCase()}
                  </Typography>
                  {/* Step Icon */}
                  <Box className="step-icon" />

                  {/* Connector line, except for the last step */}
                  {index !== tasks.length - 1 && <span className="step-connector"></span>}
                  <Box className="step-icon-container">
                    {/* Step Icon */}
                    <Box className="step-icon">
                      {task.status === 'In Progress' && (
                        <Box
                          sx={{
                            width: 16,
                            height: 16,
                            borderRadius: '50%',
                            backgroundColor: 'rgba(0, 92, 188, 1)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                          }}>
                          {/* Inner circle with radius 8 */}
                          <Box
                            sx={{
                              width: 8,
                              height: 8,
                              borderRadius: '50%',
                              backgroundColor: '#FFFFFF'
                            }}
                          />
                        </Box>
                      )}
                      {task.status === 'Completed' ? (
                        <Box
                          sx={{
                            width: 16, // Outer circle size
                            height: 16,
                            borderRadius: '50%',
                            backgroundColor: 'rgba(0, 92, 188, 1)', // Blue outer circle for 'Completed'
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            position: 'relative'
                          }}>
                          {/* White tick for 'Completed' status */}
                          <svg
                            width="10"
                            height="10"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            style={{ position: 'absolute', width: '10px', height: '10px' }}>
                            <path
                              d="M20 6L9 17L4 12"
                              stroke="#FFFFFF"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </Box>
                      ) : (
                        <Box
                          className="step-icon"
                          sx={{ backgroundColor: 'rgba(97, 97, 97, 1)' }}
                        />
                      )}
                    </Box>

                    {/* Connector line, except for the last step */}
                    {index !== tasks.length - 1 && <span className="step-connector"></span>}
                  </Box>

                  {/* Step Details */}
                  <Box className="step-details">
                    <Typography
                      component="p"
                      style={{
                        color:
                          task.status === 'Completed'
                            ? 'rgba(58, 58, 58, 1)'
                            : task.status === 'In Progress'
                              ? 'rgba(0, 92, 188, 1)'
                              : 'rgba(58, 58, 58, 1)',
                        fontWeight: task.status === 'In Progress' ? '700' : '400',
                        fontSize: '14px'
                      }}>
                      {task.status}
                    </Typography>
                  </Box>

                  {/* completedtask/totaltask completion */}
                  <Box className="step-details">
                    <Typography component="p" style={{ fontSize: '12px' }}>
                      {task.completedTask}/{task.totalTask} Tasks
                    </Typography>
                  </Box>
                  {/* due date */}
                  <Box className="step-details">
                    <Typography
                      component="p"
                      style={{
                        opacity: 1,
                        color: findStatusColor(task.status, task, true),
                        fontSize: '13px',
                        fontWeight: 400
                      }}>
                      Due: {convertDateFormat(task.dueDate)}
                    </Typography>
                  </Box>
                </Box>
              ))}
            </Box>
          </CardContent>
        </Card>
      )}
    </>
  );
};

export default CustomStepper;
